import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'

export const vehicleDiagnosticEventPropType = PropTypes.shape({
    code: PropTypes.string.isRequired,
    eventTime: iso8601PropType.isRequired,
    objectId: PropTypes.string.isRequired,
    troubleCodeId: PropTypes.string.isRequired,
    vehicleTroubleCodeEventId: PropTypes.string.isRequired,
    odometer: PropTypes.string,
    resolveTime: iso8601PropType,
    troubleCode: PropTypes.shape({
        cause: PropTypes.string,
        classification: PropTypes.string,
        code: PropTypes.string,
        effect: PropTypes.string,
        title: PropTypes.string,
        troubleCodeId: PropTypes.string,
        recommendation: PropTypes.string
    })
})
